
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DataExtractionFieldDraft"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DataExtractionFieldDraft"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"modified"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"existingField"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DataExtractionField"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedField"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DataExtractionField"},"directives":[]}]}}]}}],"loc":{"start":0,"end":227}};
    doc.loc.source = {"body":"#import \"../fragments/DataExtractionField.gql\"\n\nfragment DataExtractionFieldDraft on DataExtractionFieldDraft {\n  id\n  modified\n  existingField {\n    ...DataExtractionField\n  }\n  updatedField {\n    ...DataExtractionField\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("../fragments/DataExtractionField.gql").definitions));


      module.exports = doc;
    
